import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const resolveStoredUser = () => {
	const raw = localStorage.getItem('user')
	if (!raw) return null
	try {
		const parsed = JSON.parse(raw)
		return parsed?.user ?? parsed
	} catch (error) {
		return null
	}
}

export const useAuthStore = defineStore('auth', () => {
	const user = ref(resolveStoredUser())
	const token = ref(localStorage.getItem('access_token'))

	const isAuthenticated = computed(() => !!token.value)
	const userRoles = computed(() => user.value?.roles || [])
	const userPermissions = computed(() => user.value?.permissions || [])

	const setAuth = ({ user: userData, accessToken, token: rawToken } = {}) => {
		if (userData) {
			user.value = userData
			localStorage.setItem('user', JSON.stringify(userData))
		}

		const nextToken = accessToken || rawToken || token.value
		if (nextToken) {
			token.value = nextToken
			localStorage.setItem('access_token', nextToken)
		}
	}

	const clearAuth = () => {
		user.value = null
		token.value = null
		localStorage.removeItem('access_token')
		localStorage.removeItem('user')
	}

	const checkPermission = (permission) => {
		if (!user.value) return false
		return userPermissions.value.includes(permission)
	}

	const checkRole = (role) => {
		if (!user.value) return false
		return userRoles.value.includes(role)
	}

	const hasAnyPermission = (permissions = []) => {
		return permissions.some(permission => checkPermission(permission))
	}

	const hasAnyRole = (roles = []) => {
		return roles.some(role => checkRole(role))
	}

	return {
		user,
		token,
		isAuthenticated,
		userRoles,
		userPermissions,
		setAuth,
		clearAuth,
		checkPermission,
		checkRole,
		hasAnyPermission,
		hasAnyRole
	}
})
